import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from "../_services/authentication.service";

@Component({
    selector: 'footer',
    templateUrl: 'footer.component.html'
})

export class FooterComponent {

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService) {
    }

    @Input() resultCount?: number;

    authActionName() {
        if (AuthenticationService.isLoggedIn()) {
            return "Logga ut"
        }
        return "Logga in"
    }

    authAction() {
        if (AuthenticationService.isLoggedIn()) {
            this.authenticationService.logout('logout')
        }
        this.router.navigate(['login'], []);
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/_directives/footer.component.ts